module.exports = __webpack_public_path__ + "img/5.4b677240.png";